import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {SnackBarService} from "../../@core/services/snack-bar.service";

@Injectable({
  providedIn: 'root'
})
export class CheckService {

  constructor(private readonly http: HttpClient,
              private sb: SnackBarService) {
  }

  findByIp(ip: string): Observable<any> {
    return this.http.get<any>(`${environment.GATEWAY_URL}/check/ip/${ip}`, {withCredentials: true})
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  findByWallet(wallet: string | null): Observable<any> {
    return this.http.post<any>(`${environment.GATEWAY_URL}/check/wallet`, {
      wallet: wallet
    })
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  private onHandleError(error: HttpErrorResponse): Observable<any> {
    const message = error.error.statusCode + ' ' + (error.error.message || error.error.error);
    this.sb.openSnackBar(message, 3000, 'error');
    return of();
  }

}
